<template>
  <div
    :class="['flex flex-col', { 'items-end': store === 'apple', 'items-start': store !== 'apple' }]"
  >
    <div
      :class="[
        'relative align-middle inline-block text-transparent overflow-hidden',
        { 'text-right': store === 'apple', 'text-left': store !== 'apple' },
      ]"
    >
      <div class="text-20 text-gray-100">★★★★★</div>
      <div
        class="absolute left-0 top-0 text-20 whitespace-nowrap overflow-hidden"
        :style="`color: ${store === 'google' ? '#008761' : '#ff942e'}; width: ${(score / 5) * 100}%`"
      >
        ★★★★★
      </div>
    </div>
    <div
      class="font-bold mt-1"
      :class="{ 'text-end': store === 'apple', 'text-start': store === 'google' }"
    >
      <p class="text-22">
        {{
          store === 'google'
            ? $t('app_prompt.score_google_store')
            : $t('app_prompt.score_app_store')
        }}
      </p>
      <div class="flex items-center justify-center">
        <svg role="presentation" focusable="false" tabindex="-1" v-if="!logoHidden && store === 'apple'"
           
          alt=""
          class="mr-1"
          svg-inline
         width="12" height="14" fill="none"><title>class="mr-1</title>
  <path fill="#DDD" d="M9.53 7.42a3.17 3.17 0 0 1 1.51-2.66A3.24 3.24 0 0 0 8.5 3.38c-1.08-.12-2.12.64-2.67.64-.56 0-1.4-.63-2.3-.61A3.4 3.4 0 0 0 .64 5.14c-1.24 2.14-.32 5.3.87 7.03.6.85 1.28 1.8 2.2 1.76.88-.04 1.21-.57 2.28-.57 1.07 0 1.38.57 2.3.55.96-.02 1.56-.85 2.13-1.71a7.02 7.02 0 0 0 .97-1.98 3.06 3.06 0 0 1-1.87-2.82ZM7.8 2.24A3.12 3.12 0 0 0 8.48 0a3.17 3.17 0 0 0-2.05 1.06 2.97 2.97 0 0 0-.73 2.16 2.62 2.62 0 0 0 2.07-.99Z"/>
</svg>
        <p class="text-12">
          {{ store === 'google' ? $t('app_prompt.google_play') : $t('app_prompt.app_store') }}
        </p>
        <svg role="presentation" focusable="false" tabindex="-1" v-if="!logoHidden && store === 'google'"
           
          alt=""
          class="ml-1"
          svg-inline
         width="12" height="13" fill="none"><title>class="ml-1</title>
  <path fill="#EB3131" d="M5.35 6.1.11 11.66a1.41 1.41 0 0 0 2.08.85l.02-.01 5.9-3.39-2.76-3Z"/>
  <path fill="#F6B60B" d="M10.65 5.16 8.1 3.69 5.23 6.23 8.11 9.1l2.53-1.46a1.41 1.41 0 0 0 .01-2.48Z"/>
  <path fill="#5778C5" d="M.1 1.13a1.38 1.38 0 0 0-.04.36v9.8c0 .12.02.24.05.36l5.42-5.4L.11 1.13Z"/>
  <path fill="#3BAD49" d="m5.39 6.39 2.71-2.7L2.2.29a1.42 1.42 0 0 0-.72-.2C.82.08.27.52.1 1.12L5.39 6.4Z"/>
</svg>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps<{ logoHidden?: boolean; store: 'google' | 'apple' }>()

const { $t } = useNuxtApp()

const score = computed(() => {
  if (props.store === 'google') {
    return Number($t('app_prompt.score_google_store').replace(',', '.'))
  }
  return Number($t('app_prompt.score_app_store').replace(',', '.'))
})
</script>
